import { CalculationUsageTracking } from './calculation-usage-tracking';
import { ClickedUsageTracking } from './clicked-usage-tracking';
import { NavigationUsageTracking } from './navigation-usage-tracking';

export type UsageTrackingTypes =
  | NavigationUsageTracking
  | ClickedUsageTracking
  | CalculationUsageTracking;
